import React from 'react';
import PropTypes from 'prop-types';

import ArrowBack from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import Theme from 'LegacyWeployDesignLanguage/Theme';

import commonStyles from './styles';

const styles = () => ({
  icon: {
    ...commonStyles().icon,
    fontSize: Theme.icons.default,
    // TODO: Default Icon size set to default -> revisit this later with a more flexible way to change Icon size
  },
  largeIcon: {
    ...commonStyles().icon,
    fontSize: '54px',
  },
});

const LeftArrowIconButton = ({
  size,
  classes,
  onClick,
}) => {
  const className = size === 'large' ? classes.largeIcon : classes.icon;

  return (
    <IconButton onClick={onClick}>
      <ArrowBack className={className} />
    </IconButton>
  );
};

LeftArrowIconButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.string,
};

LeftArrowIconButton.defaultProps = {
  onClick: () => {},
  size: '',
};

export default withStyles(styles)(LeftArrowIconButton);
